import React, { FC } from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

const StyledProgressContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  .MuiCircularProgress-svg {
    color: ${({ color }) => color};
  }
`;

export interface LoadingProps {
  color?: string;
  size?: string;
}

const Loading: FC<LoadingProps> = ({
  color = 'var(--primary-color)',
  size,
  ...rest
}) => (
  <StyledProgressContainer color={color} {...rest}>
    <CircularProgress size={size} disableShrink />
  </StyledProgressContainer>
);

export default Loading;
